import { useMemo } from 'react';
import { useGetProjectsQuery } from '@/slices/projectSlice';

const useJobs = ({ _customer, skip } = { _customer: '', skip: false }) => {
	const { data, isLoading, isError } = useGetProjectsQuery(undefined, { skip });

	const jobs = useMemo(() => {
		if (!data?.ids) return [];

		return data.ids
			.map((id) => data.entities[id])
			.filter((project) => project.job)
			.filter((project) => {
				if (!_customer) return true;
				return project._customer === _customer;
			})
			.map((project) => ({
				...project.job,
				number: project.number,
				customer: project.customer,
				properties: project.properties,
				_project: project._id,
				type: 'job',
			}));
	}, [data, _customer]);

	return { jobs, isLoading, isError };
};

export default useJobs;
